import {
  SearchProduct as ApiSearchProduct,
  ShowProduct as ApiShowProduct,
} from "@/api/products";
import { SearchMenu as ApiSearchMenu } from "@/api/menu";
import { SearchCategory as ApiSearchCategory } from "@/api/categories";
import { SearchBrand as ApiSearchBrand } from "@/api/brands";
import { SearchGroup as ApiSearchGroup } from "@/api/groups";
import { SearchState as ApiSearchState } from "@/api/states";
import { GetCategory as ApiGetCategory } from "@/api/category";
import { SearchSlider as ApiSearchSlider } from "@/api/sliders";
import { genders } from "@/config/constants";

const convert = (products) => {
  return products.map((product) => {
    let cover = null;
    let slides = [];
    // let iconBrand = null;
    if (product.images && product.images.length) {
      cover = product.base_url + product.images[0].url;
      slides = product.images.map((img) => product.base_url + img.url);
      // return { ...product, cover, images: slides };
    }
    // if (product.brand_icon) {
    //   iconBrand = product.base_url + product.brand_icon.url;
    // }
    return { ...product, cover, slides };
  });
};

const state = {
  menu: [],
  categories: [],
  brands: [],
  groups: [],
  states: [],
  genders: [...genders],
  relatedProducts: [],
  products: [],
  product: {},
  payload: {},
  category: null,
  sliders: [],
  isLoading: false,
  availableProducts: 0,
};

const getters = {
  getAllProducts: (state) => state.products,
};

const mutations = {
  setLoadingState(state, playload) {
    state.isLoading = playload;
  },

  resetStore(state) {
    return (state.categories = []), (state.products = []);
  },

  setMenu(state, menu) {
    state.menu = menu;
  },

  setCategories(state, categories) {
    state.categories = categories;
  },

  setBrands(state, brands) {
    state.brands = brands;
  },

  setGroups(state, groups) {
    state.groups = groups;
  },

  setStates(state, states) {
    state.states = states;
  },

  setProducts(state, products) {
    state.products = products;
  },

  setAvailableProducts(state, availableProducts) {
    state.availableProducts = availableProducts;
  },

  setProduct(state, product) {
    state.product = product[0];
  },

  setRelatedProducts(state, payload) {
    state.relatedProducts = payload;
  },

  mergeProducts(state) {
    if (state.payload.page) {
      state.payload.page++;
    } else {
      state.payload.page = 1;
    }

    ApiSearchProduct(state.payload)
      .then((response) => {
        const products = convert(response.data);

        if (state.payload.page == 1) {
          // context.commit("setProducts", convert(response.data));
          state.products = products;
        } else {
          products.forEach((item) => {
            state.products.push(item);
          });
        }
      })
      .catch(() => {
        this.loading = false;
      });
  },

  sortProducts(state, payload) {
    var products = state.products.sort((a, b) => {
      if (payload.price === 1) {
        return Number(a.price) < Number(b.price) ? 1 : -1;
      } else {
        return Number(a.price) > Number(b.price) ? 1 : -1;
      }
    });

    products = products.sort((a, b) => {
      if (payload.date === 1) {
        return Date(a.updated_at) < Date(b.updated_at) ? 1 : -1;
      } else {
        return Date(a.updated_at) > Date(b.updated_at) ? 1 : -1;
      }
    });
    state.products = products;
  },

  setPayload(state, payload) {
    state.payload = payload;
  },

  setCategory(state, category) {
    state.category = category;
  },

  setSliders(state, sliders) {
    state.sliders = sliders;
  },
};

const actions = {
  getMenu(context) {
    ApiSearchMenu()
      .then((response) => {
        context.commit("setMenu", response.data);
      })
      .catch(() => {});
  },

  getCategories(context) {
    ApiSearchCategory()
      .then((response) => {
        context.commit("setCategories", response.data);
      })
      .catch(() => {});
  },

  getBrands(context) {
    ApiSearchBrand()
      .then((response) => {
        context.commit("setBrands", response.data);
      })
      .catch(() => {});
  },

  getGroups(context) {
    ApiSearchGroup()
      .then((response) => {
        context.commit("setGroups", response.data);
      })
      .catch(() => {});
  },

  getStates(context) {
    ApiSearchState()
      .then((response) => {
        context.commit("setStates", response.data);
      })
      .catch(() => {});
  },

  getRelatedProducts(context, payload) {
    ApiSearchProduct(payload)
      .then((response) => {
        context.commit("setRelatedProducts", response.data);
      })
      .catch(() => {});
  },

  commitFilter(context, payload) {
    context.commit("setPayload", payload);
  },

  getProducts(context, payload) {
    context.commit("setLoadingState", true);
    context.commit("setPayload", payload);
    ApiSearchProduct(payload)
      .then((response) => {
        context.commit("setLoadingState", false);
        // console.log(convert(response.data));
        context.commit("setProducts", convert(response.data));
        context.commit("setAvailableProducts", response.pagination.total);
      })
      .catch(() => {
        context.commit("setLoadingState", false);
      });
  },

  getProduct(context, payload) {
    context.commit("setLoadingState", true);
    ApiShowProduct({ id: payload })
      .then((response) => {
        context.commit("setLoadingState", false);
        context.commit("setProduct", convert([response.data]));

        ApiSearchProduct({ filter: { category_id: response.data.category_id }, page: 1 })
          .then((response) => {
            const relatedProducts = response.data.filter((x) => x.id !== payload);
            context.commit("setRelatedProducts", convert(relatedProducts));
          })
          .catch(() => {});
      })
      .catch(() => {
        context.commit("setLoadingState", false);
      });

    // ApiSearchProduct({ page: 1 })
    //   .then((response) => {
    //     const relatedProducts = response.data.filter((x) => x.id !== payload);
    //     context.commit("setRelatedProducts", convert(relatedProducts));
    //   })
    //   .catch(() => {});
  },

  mergeProducts(context) {
    context.commit("mergeProducts");
  },

  sortProducts(context, payload) {
    context.commit("sortProducts", payload);
  },

  getCategory(context, payload) {
    context.commit("setLoadingState", true);
    payload = payload.replace("api/", "");    
    ApiGetCategory(payload)
      .then((response) => {
        context.commit("setLoadingState", false);
        context.commit("setCategory", response.data);
      })
      .catch(() => {
        context.commit("setLoadingState", false);
      });
  },

  getSliders(context) {
    ApiSearchSlider()
      .then((response) => {
        context.commit("setSliders", response.data);
      })
      .catch(() => {});
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
